// extracted by mini-css-extract-plugin
export var leftAlign = "_1r-2";
export var popper = "_1r-0";
export var subtitle = "_1r-1";